import { render, staticRenderFns } from "./dashboardoutline.vue?vue&type=template&id=9621fcc4&"
import script from "./dashboardoutline.vue?vue&type=script&lang=js&"
export * from "./dashboardoutline.vue?vue&type=script&lang=js&"
import style0 from "./dashboardoutline.vue?vue&type=style&index=0&id=9621fcc4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports